import { render, staticRenderFns } from "./SubscriptionChange.vue?vue&type=template&id=40e856e2&scoped=true"
import script from "./SubscriptionChange.vue?vue&type=script&lang=js"
export * from "./SubscriptionChange.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionChange.vue?vue&type=style&index=0&id=40e856e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e856e2",
  null
  
)

export default component.exports